<template>
  <footer id="footer">
    <div class="container">
      <div class="d-flex flex-column flex-md-row">
        <div class="organizer d-flex">
          <img :src="moe" alt="教育部" class="d-none d-xl-inline" />
          <div class="d-flex flex-md-column">
            <div class="org-title me-2 me-lg-0 mb-2 mb-lg-0">Sponsor</div>
            <div class="org-name small-text">Ministry of Education</div>
          </div>
        </div>
        <div class="organizer d-flex">
          <img :src="yuntech" alt="雲林科技大學" class="d-none d-xl-inline" />
          <div class="d-flex flex-md-column">
            <div class="org-title me-2 me-lg-0 mb-2 mb-lg-0">Organizer</div>
            <div class="org-name small-text">NYUST</div>
          </div>
        </div>
        <div class="organizer d-flex">
          <img
            :src="nantech"
            alt="台南應用科技大學"
            class="d-none d-xl-inline"
          />
          <div class="d-flex flex-md-column">
            <div class="org-title me-2 me-lg-0 mb-2 mb-lg-0">Co-organizer</div>
            <div class="org-name small-text">TUT</div>
          </div>
        </div>
        <div id="contact-us" class="d-flex ms-lg-auto">
          <div class="org-name fw-bold me-2">Contact</div>
          <div class="org-name">
            <div class="d-flex flex-column flex-lg-row">
              <span class="me-2">Department of Digital Media Design (DMD)</span>
            </div>
            <div class="d-flex flex-column flex-lg-row">
              <span class="me-2"
                >National Yunlin University of Science and Technology
                (NYUST)</span
              >
            </div>
            <div>
              123 University Road, Section 3,Douliou, Yunlin 62402, Taiwan,
              R.O.C.
            </div>
            <div>
              +886-5-5342601 ext. 6593 <span>/ dmd@yuntech.edu.tw</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import moe from '@/assets/img/moe.png';
import yuntech from '@/assets/img/yuntech.png';
import nantech from '@/assets/img/nantech.png';

export default {
  data() {
    return {
      moe,
      yuntech,
      nantech,
    };
  },
};
</script>
<style lang="stylus" scoped>
#footer
  background: $monoc4;
  color: $contract1;
  padding: 36px 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 100;

.organizer
  margin-right: 24px;

  img
    margin-right: 8px;
    width: 36px;
    height: 36px;

.org-title
  font-style: normal;
  font-weight: bold;
  font-size: 9px;

@media screen and (max-width: 767.4px)
  .org-title, .org-name
    font-size: 14px !important;

  .container
    padding-left: 24px !important;
    padding-left: 24px !important;
</style>
